import {Rect} from '../../types';

interface RectLabelProps {
  rect: Rect;
  scale?: number;
}

const LABEL_SIZE = 24;
const FONT_SIZE = 14;
const TEXT_OFFSET = 4;
const PADDING = 8;

export const RectLabel = ({rect, scale = 1}: RectLabelProps) => {
  if (!rect.name || rect.name === '-') return null;

  const labelSize = LABEL_SIZE / scale;

  const minSize = labelSize * 2.5;
  const canPlaceInside = rect.width >= minSize && rect.height >= minSize;

  const position = canPlaceInside
    ? {
        left: PADDING,
        top: PADDING,
      }
    : {
        left: -labelSize - TEXT_OFFSET / scale,
        top: PADDING,
      };

  return (
    <div
      className="pointer-events-none absolute"
      style={{
        left: `${position.left}px`,
        top: `${position.top}px`,
        width: `${labelSize}px`,
        height: `${labelSize}px`,
      }}
    >
      <div
        className="absolute h-full w-full rounded-full"
        style={{backgroundColor: rect.color || '#e43897'}}
      />
      <span
        className="absolute inset-0 flex items-center justify-center font-medium text-text-contrast"
        style={{fontSize: `${FONT_SIZE / scale}px`}}
      >
        {rect.name}
      </span>
    </div>
  );
};
